/** angular */
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { BydAlertData } from './models/byd-alert-data.model';
/** end angular */

@Component({
  selector: 'byd-alert',
  templateUrl: './byd-alert.component.html',
  styleUrls: ['./byd-alert.component.scss'],
})
export class BydAlertComponent {
  /**
   *
   */
  @Input() data: BydAlertData;

  /**
   *
   */
  @Input() toolTip: string;

  /**
   *
   */
  @Output() close = new EventEmitter();

  /**
   * Second action click.
   */
  @Output() secondAction = new EventEmitter();

  /**
   * Close the dialog opened via the MatDialog service.
   */
  onClose() {
    this.close.emit();
  }
}
